import * as React from "react";
import type { SVGProps } from "react";
const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M5 11a6 6 0 1 1 3.452 5.434 1 1 0 0 0-.851 1.81A8 8 0 0 0 11 19a7.97 7.97 0 0 0 4.906-1.68l.387.387 3 3 .707.707L21.414 20l-.707-.707-3-3-.387-.387a8 8 0 1 0-13.15-.74 1 1 0 0 0 1.706-1.043A5.97 5.97 0 0 1 5 11"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgSearch;
